import { factoryService, getJsonRequest, postJsonRequest } from '@chilecompra/react-kit/requests'
import { normalizeDniSlashes } from '../modules/utils/normalizeForeignDni'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'

/**
 * Get basic seller information.
 */
export const getBasicSellerInformation = factoryService(({ dni, isForeign }) => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v3/proveedor/estado/${normalizeDniSlashes(dni)}/${isForeign}`)
})

/**
 * Get the awarded agreements count, contractual behavior and sales in MP.
 */
export const getSummaryInformation = factoryService(({ dni }) => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/proveedor/summaryficha/${normalizeDniSlashes(dni)}`)
})

/**
 * Get the contacts of the given seller.
 */
export const getContacts = factoryService(({ dni }) => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/proveedor/contactos/${normalizeDniSlashes(dni)}`)
})

/**
 * Get the legal address of the given seller.
 */
export const getLegalAddress = factoryService(({ dni, isForeign }) => {
  return getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/proveedor/ficha/direccion/${normalizeDniSlashes(dni)}/${isForeign}`
  )
})

/**
 * Get the company managers of the given seller from affidavit.
 */
export const getCompanyManagersAffidavit = factoryService(({ dni }) => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/proveedor/ficha/administracion/${normalizeDniSlashes(dni)}`)
})

/**
 * Gets the seller stamps data.
 */
export const getSellerStamps = factoryService(({ dni }) => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/sello/sellos-proveedor/${normalizeDniSlashes(dni)}`)
})

/**
 * Get the information for the seller if is blocked.
 */
export const postBlockedInformation = factoryService(({ dni, isForeign, isLog, module }) => {
  const body = {
    isForeign,
    isLog,
    modulo: module,
    rut: normalizeDniSlashes(dni)
  }
  return postJsonRequest(`${REACT_APP_API_BASE_URL}/v1/proveedor/ficha/bloqueado`, { body })
})
